export const deltaTypeValues = ["increase", "decrease", "neutral", "belowTarget", "hitTarget"] as const;

export type DeltaType = (typeof deltaTypeValues)[number];

export const DeltaTypes = {
  Increase: "increase",
  Decrease: "decrease",
  Neutral: "neutral",
  BelowTarget: "belowTarget",
  HitTarget: "hitTarget",
} as const;
